import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/3d-game/tech_stack.webp";
import { StaticImage } from "gatsby-plugin-image";

function Techstackthreed() {
  return (
    <section
      className="tech_stack_threed p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Cutting-Edge Tech Stack for Immersive{" "}
              <span>Gaming Experiences</span>
            </h2>
            <p>
              We use a wide set of powerful tools and various
              industry-recognized frameworks that help us build beautiful,
              efficient, and safe game environments. This technology helps us
              create multiplatform scalable games that will perform equally well
              on different devices.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="tech-stack-main">
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/blender.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>Blender</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/substance_painter.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>Substance Painter</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/unreal_engine.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>Unreal Engine</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/unity.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>Unity</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/phaser.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={225}
                    height={90}
                  />
                </div>
                <h6>Phaser</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/z_brush.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>ZBrush</h6>
              </div>
              <div className="teck-stack-item">
                <div className="teck-stack-icon">
                  <StaticImage
                    src="../../images/services-usa/3d-game/tech-stack/maya.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                </div>
                <h6>Maya</h6>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Techstackthreed;
